import { render, staticRenderFns } from "./FindSubmissions.vue?vue&type=template&id=5ffbad88&scoped=true"
import script from "./FindSubmissions.vue?vue&type=script&lang=js"
export * from "./FindSubmissions.vue?vue&type=script&lang=js"
import style0 from "./FindSubmissions.vue?vue&type=style&index=0&id=5ffbad88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbad88",
  null
  
)

export default component.exports